/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        sash: hsl(2, 59, 65),
        bennettKurta: hsl(214, 45, 60),
        garland: hsl(79, 14, 77),
        garlandFlower: hsl(15, 52, 69),

        recorderBrass: hsl(46, 28, 61),
        recorderPadding: hsl(65, 28, 61),
        recorderLight: hsl(330, 12, 45),
        recorderTrim: hsl(341, 10, 43),
        recorderDark: hsl(330, 12, 39),
        recorderInner: hsl(327, 7, 31),

        sari: hsl(120, 52, 69),
        cymbalBand: hsl(119, 26, 46),

        cymbalCentre: hsl(46, 21, 49),
        cymbalOuter: hsl(47, 41, 53),
        cymbalInner: hsl(46, 25, 54),

        sockWhite: hsl(0, 0, 87),

        sariTrim: hsl(35, 61, 67),
        clothingGold: hsl(41, 50, 53),
    },
}
